import script from "./ExtendedStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExtendedStatus.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__